module.exports = __webpack_public_path__ + "img/tws3.c5915fd1.png";